
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/novice",
      function () {
        return require("private-next-pages/novice.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/novice"])
      });
    }
  